import { useMemo } from 'react';
import { useProcesosStaff } from './useInstancias';
import { useMisPostulaciones } from './usePostulaciones';
import { agruparStaff } from '../utils/agruparStaff';

/**
 * Lo que espera acción del usuario en "Mis Procesos": solicitudes por resolver
 * (de los temas que guía o coguía) + revisiones de comisión que aún no evalúa.
 * Alimenta el contador de la barra lateral.
 *
 * Cuenta solo lo propio, también para el coordinador: `me/postulaciones/` sin
 * `todas` devuelve únicamente las de sus temas, y `porRevisar` mira las comisiones
 * que integra. Así el contador no se le llena con el trabajo de todo el sistema.
 *
 * Usa la misma consulta que "Mis Procesos" sin semestre (lo que está en curso), que
 * es donde vive todo lo que puede estar por revisar. Antes pedía el listado completo
 * —miles de procesos para el coordinador— **en cada página**, solo para poner un
 * número en la barra lateral; ahora comparte la caché de la vista de procesos.
 */
export function usePendientesProcesos(enabled = true) {
  const { data: postulaciones } = useMisPostulaciones(enabled);
  const { data: instancias } = useProcesosStaff('', enabled);

  return useMemo(() => {
    const solicitudes = (postulaciones ?? []).filter((p) => p.estado === 'pendiente').length;
    const revisiones = instancias ? agruparStaff(instancias).porRevisar : 0;
    return { solicitudes, revisiones, total: solicitudes + revisiones };
  }, [postulaciones, instancias]);
}
